namespace advisorop.components.advisor {

    export class PerformanceGridController {
        performanceDetails: Array<any>;
        rtgId: number;
        showNeto: boolean = true;
        hideSleeves: boolean = false;
        dg: DevExpress.ui.dxDataGridOptions;

        // instance of performance grid
        dgPerformanceGrid: DevExpress.ui.dxDataGrid;

        constructor(private advisorService: services.AdvisorService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "PerformanceDetails"
                },
                bindingOptions: {
                    dataSource: "vm.performanceDetails",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    //pageSize: 5,
                    enabled: false
                },
                rowAlternationEnabled: false,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgPerformanceGrid = e.component;
                },
                wordWrapEnabled: true,

                columns: [

                    { dataField: "groupDescription", caption: "", width: 402 },
                    { dataField: "mtdPerfNet", caption: "MTD", format: { type: "percent", precision: 2 }, alignment: "right", width: 65 },
                    { dataField: "qtdPerfNet", caption: "QTD", format: { type: "percent", precision: 2 }, alignment: "right", width: 65 },
                    { dataField: "ytdPerfNet", caption: "YTD", format: { type: "percent", precision: 2 }, alignment: "right", width: 65 },
                    { dataField: "prevYrPerfNet", caption: "1 Yr", format: { type: "percent", precision: 2 }, alignment: "right", width: 65 },
                    { dataField: "prev3YrPerfNet", caption: "3 Yr", format: { type: "percent", precision: 2 }, alignment: "right", width: 65 },
                    { dataField: "prev5YrPerfNet", caption: "5 Yr", format: { type: "percent", precision: 2 }, alignment: "right", width: 65 },
                    { dataField: "inceptPerfCumNet", caption: "Inception (Cumulative)", format: { type: "percent", precision: 2 }, alignment: "right", width: 80 },
                    { dataField: "inceptPerfAnnlzdNet", caption: "Inception (Annualized)", format: { type: "percent", precision: 2 }, alignment: "right", width: 80 },

                    //{ dataField: "mtdPerfGross", caption: "MTD", format: { type: "percent", precision: 2 }, visible: !this.showNeto, width: 60 },
                    //{ dataField: "qtdPerfGross", caption: "QTD", format: { type: "percent", precision: 2 }, visible: !this.showNeto, width: 60 },
                    //{ dataField: "ytdPerfGross", caption: "YTD", format: { type: "percent", precision: 2 }, visible: !this.showNeto, width: 60 },
                    //{ dataField: "prevYrPerfGross", caption: "1 Yr", format: { type: "percent", precision: 2 }, visible: !this.showNeto, width: 60 },
                    ////{ dataField: "prev2YrGross", caption: "Prev2Yr", format: { type: "percent", precision:2 }, visible: !this.showNeto },
                    //{ dataField: "prev3YrPerfGross", caption: "3 Yr", format: { type: "percent", precision: 2 }, visible: !this.showNeto, width: 60 },
                    //{ dataField: "prev5YrPerfGross", caption: "5 Yr", format: { type: "percent", precision: 2 }, visible: !this.showNeto, width: 60 },
                    //{ dataField: "inceptPerfCumGross", caption: "Inception (Cumulative)", format: { type: "percent", precision: 2 }, visible: !this.showNeto, width: 60 },
                    //{ dataField: "inceptPerfAnnlzdGross", caption: "Inception (Annualized)", format: { type: "percent", precision: 2 }, visible: !this.showNeto, width: 80 }
                ],
                masterDetail: {
                    enabled: true,
                    template: "detail",
                    autoExpandAll: true
                }
            };

        }

        onc3 = function (e: any) {
            if (e.rowType === 'data' && e.column.command === 'expand') {
                // console.log('eeee', e);
                if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                    e.cellElement.removeClass('dx-datagrid-expand');
                    e.cellElement.empty();
                }
            }
            if (e.rowType === 'header' && e.column && (e.column.dataField === 'openDate' || e.column.dataField === 'performance.openDate')) {
                e.cellElement.attr('title', 'Sourced from Orion');
            }
        }

        $onInit(): void {
        }

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "performanceDetails" && this.performanceDetails) {
                    //console.log("Performance details data: ");
                    //console.log(this.performanceDetails);
                }
            }
        };
    }



    class PerformanceGrid implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;


        constructor() {
            this.bindings = {
                performanceDetails: "<"
            };
            this.controller = ["advisorService", PerformanceGridController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/performance-grid.html";
        }
    }
    angular.module(Constants.APP).component("performanceGrid", new PerformanceGrid());

}